import React, { createContext } from "react";

export const AppContext = createContext({
  data: {
    test: "test",
  },
  set: () => {},
});

export class ContextProviderComponent extends React.Component {
  constructor() {
    super();

    this.setData = this.setData.bind(this);
    this.state = {
      data: {
        test: "test",
        contactFormOpen: false,
      },
      set: this.setData,
    };
  }

  setData(newData) {
    this.setState((state) => ({
      data: {
        ...state.data,
        ...newData,
      },
    }));
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

// Export ContextConsumer for use in components
export const ContextConsumer = AppContext.Consumer;
